import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Plus } from 'lucide-react'
import { useQueueMachines } from '@/hooks/useQueueMachines'
import { Skeleton } from '@/components/ui/skeleton'
import { useViewMode } from '@/stores/viewMode'
import { DataTable } from './data-table'
import { QueueMachineDialog } from './QueueMachineDialog'
import { columns } from './columns'

export default function QueueMachinesPage() {
  const { id: clinicId } = useViewMode()

  const [page] = useState(1)
  const [pageSize] = useState(10)
  const [showAddDialog, setShowAddDialog] = useState(false)

  const { queueMachines, isLoading, isError, mutate } = useQueueMachines({
    page,
    pageSize,
    clinic_id: clinicId,
  })

  if (isError) {
    return (
      <div>
        <div className="text-center text-destructive">載入叫號機列表失敗。請稍後再試。</div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div>
        <Skeleton className="h-8 w-[200px] mb-4" />
        <Skeleton className="h-[400px] w-full" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">叫號機管理</h2>
          <p className="text-muted-foreground mt-2">管理診所叫號機</p>
        </div>
        <Button onClick={() => setShowAddDialog(true)}>
          <Plus className="mr-2 h-4 w-4" />
          新增叫號機
        </Button>
      </div>

      <Card>
        <CardContent className="p-6">
          <DataTable
            columns={columns}
            data={queueMachines || []}
            meta={{
              reloadData: () => mutate(),
            }}
          />
        </CardContent>
      </Card>

      <QueueMachineDialog
        open={showAddDialog}
        onOpenChange={setShowAddDialog}
        clinicId={clinicId}
        onSuccess={() => mutate()}
      />
    </div>
  )
}
